import React, { useContext, useState } from "react";
import InterestContext from "../../context/interest/interestContext";
import AdminInterestContext from "../../context/adminInterest/adminInterestContext";
import * as GrIcons from "react-icons/gr";

const SiteItem = ({ data, setSite, selectedSite }) => {
  const {
    name,
    charter,
    distance,
    address: { state, address_1, city, zip },
  } = data;
  return (
    <tr>
      <td>{name}</td>
      <td>{charter}</td>
      <td>{`${address_1}, ${city}, ${state}, ${zip}`}</td>
      <td>{distance}</td>
      {Object.keys(selectedSite).length === 0 && (
        <td>
          <div
            onClick={() => {
              setSite(data);
            }}
            className="btn btn-llac-light-grey"
          >
            Select
          </div>
        </td>
      )}
    </tr>
  );
};

const SiteZipSearchModal = ({ setFormData, formData }) => {
  const adminInterestContext = useContext(AdminInterestContext);
  const { setFormModal } = adminInterestContext;
  const interestContext = useContext(InterestContext);
  const { getZipLocations, zipSites } = interestContext;
  const [radius, setRadius] = useState(15);
  const [zipcode, setZipcode] = useState("");
  const [selectedSite, setSelectedSite] = useState({});

   const brand="llac"

  const onSubmit = (e) => {
    e.preventDefault();
    setSelectedSite({});
    getZipLocations(brand, "NULL", "NULL", zipcode, "NULL", "NULL");
  };

  return (
    <div id="site-zip-search-modal" className="modal">
      <div className="zip-modal-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("siteZipSearchModal", false)}
          />
          <h2>Search Sites by Zipcode</h2>
        </div>
        <div className="modal-body">
          <form className="form" onSubmit={onSubmit}>
            <div className="search-bar">
              <input
                type="text"
                value={zipcode}
                onChange={(e) => setZipcode(e.target.value)}
                placeholder="Enter Zipcode"
              />
              
              <input
                type="submit"
                value="Search Sites"
                className="btn btn-llac-light-green"
              />
            </div>
          </form>
          <div className="search-results">
            <table>
              <tr>
                <th>Name</th>
                <th>Charter</th>
                <th>Address</th>
                <th>Distance</th>
                {Object.keys(selectedSite).length === 0 && <th>Action</th>}
              </tr>
              {zipSites.length > 0 ? (
                Object.keys(selectedSite).length !== 0 ? (
                  <SiteItem
                    data={selectedSite}
                    setSite={setSelectedSite}
                    selectedSite={selectedSite}
                  />
                ) : (
                  zipSites.map((item) => {
                    return (
                      <SiteItem
                        data={item}
                        setSite={setSelectedSite}
                        selectedSite={selectedSite}
                      />
                    );
                  })
                )
              ) : null}
            </table>
          </div>
        </div>
        <div className="bottom-bar">
          <div className="btns">
            {Object.keys(selectedSite).length !== 0 && (
              <div
                onClick={() => {
                  setFormData({
                    ...formData,
                    learningCenterId: selectedSite.id,
                    learningCenterName: selectedSite.name,
                    learningCenterCharter: selectedSite.charter,
                    learningCenterAddress: `${selectedSite.address.address_1}, ${selectedSite.address.city}, ${selectedSite.address.state}, ${selectedSite.address.zip}`,
                    learningCenterCoordinates: selectedSite.address.coordinates,
                  });
                  setFormModal("siteZipSearchModal", false);
                }}
                className={`btn btn-llac-dark-green`}
              >
                Confirm Site
              </div>
            )}
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("siteZipSearchModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteZipSearchModal;
